import { APP_BRAND } from '@/config/brand';
import { getBrandConfig } from '@/config/brandConfig';
import { aiIcon } from '@/assets/icons';
import { AssetIcon, type AssetIconProps } from './AssetIcon';

export type BrandMarkIconProps = Omit<AssetIconProps, 'src' | 'alt'>;

/** Circular AI shield badge — AG purple (Figma AI-Icon), HID blue (AI-Icon-HID.svg). */
export function BrandMarkIcon({ size = 32, className, ...props }: BrandMarkIconProps) {
  const brandConfig = getBrandConfig();

  if (APP_BRAND === 'hid' && brandConfig.hidAiIcon) {
    return (
      <AssetIcon
        src={brandConfig.hidAiIcon}
        size={size}
        className={className}
        alt=""
        aria-hidden
        {...props}
      />
    );
  }

  return <AssetIcon src={aiIcon} size={size} className={className} {...props} />;
}
